"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_URLS = exports.SESSION_PROPERTIES = exports.USER_DATA = exports.LOCAL_STORAGE_FIVE9_ITEM = exports.PIPES_CONFIG = exports.CSS_STYLES = void 0;
exports.CSS_STYLES = {
    DISPLAY: {
        NONE: "none",
        FLEX: "flex",
        BLOCK: "block",
    },
    VISIBILITY: {
        HIDDEN: "hidden",
        VISIBLE: "visible",
    },
    DISABLED: {
        true: "true",
        false: "false",
    },
    BOTTOM_INFORMATIONAL_MESSAGE: {
        MINIMUM: 100,
        BASE_CHARACTERS: 45,
        UP_SIZE: 20,
    },
};
exports.PIPES_CONFIG = {
    retry: 2,
    debounceTime: 1000,
};
/** Nombre de nuestro objeto five9 que gestiona la instancia del chat */
exports.LOCAL_STORAGE_FIVE9_ITEM = "siigo-five9-instance";
// Constante para obtener el token de validación
exports.USER_DATA = "stark:yvdrjs===dk2";
exports.SESSION_PROPERTIES = {
    status: "status",
    configurations: "configurations",
    chatData: "chatData",
};
// URLS diferenciadas por paises de los posibles lugares donde hacen el llamado del chat
exports.COUNTRY_URLS = {
    COLOMBIA_SIIGO_NUBE: [
        "siigonube.siigo.com",
        "qastaging.siigo.com",
        "localhost:4200",
        "localhost:8670",
    ],
    COLOMBIA_SIIGO: ["siigo.com"],
    CHILE: ["siigonube.siigo.cl", "qastaging.siigo.cl"],
    CONTIFICO: [
        //Ecuador
        "contifico.com",
    ],
};
//# sourceMappingURL=constants.js.map